import { As } from '@chakra-ui/react';
import { Button, IButtonProps } from 'ui-components/dist/Button';

interface Props extends IButtonProps {
  onClick: () => void;
  title: string;
  icon: As;
}

export const LinkButton: React.FC<Props> = ({
  title,
  icon: Icon,
  ...props
}) => (
  <Button
    variant="primary"
    aria-label={title}
    leftIcon={<Icon className="size-4" />}
    {...props}
  >
    {title}
  </Button>
);
